import api from "services/api";

export async function fetchListTitleNames() {
  const res = await api.get("/ListTitleName");
  return res.data;
}
